import {Component, OnInit, OnDestroy, AfterViewInit, ViewChild, ElementRef} from '@angular/core';
//import {FormBuilder} from '@angular/forms';
import {Router, ActivatedRoute} from '@angular/router';
import { environment } from 'environments/environment';
import {Subscription} from 'rxjs';
import {AuthService} from '../shared/auth/auth.service';
// import {FooterComponent} from '../shared/footer/footer.component';
@Component({
  selector: 'landingpage',
  templateUrl: './landing-page.component.html'
})
export class LandingPageComponent implements OnInit, OnDestroy{
  baseSystem = environment.baseSystem;
  bg_image:any="";
  config: any = {
    pagination: '.swiper-pagination',
    paginationClickable: true,
    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev',
    slidesPerView: 1,
    slidesPerColumn: 1,
    spaceBetween: 10,
    autoplay: 5000, 
    autoplayDisableOnInteraction: false

    };

    
  pageHeight: number;
  footerHeight: number;

  // @ViewChild('stickyfooter')
  // stickyFooterChild: FooterComponent;


  constructor(private _route: ActivatedRoute,
    private _router: Router,
    public authService:AuthService) {
}


ngOnInit(){

}

ngOnDestroy(){
  
}

// ngAfterViewInit(){
//   this.stickyFooterChild.stickyFooter.nativeElement.style = '5%!important';
//   console.log(this.stickyFooterChild.stickyFooter.nativeElement.whoAmI()); // 👶 I am a child!
// }

}



// WEBPACK FOOTER //
// ./src/app/landing-page/landing-page.component.ts